/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _maybeAddCheckboxColumn = _interopRequireDefault(require("./maybeAddCheckboxColumn"));
function _default(columns, props) {
  if (props.maybeAddColumns) {
    columns = props.maybeAddColumns(columns, props);
  }
  columns = (0, _maybeAddCheckboxColumn.default)(columns, props);
  return columns;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/normalizeColumns/useBuildColumns.js
// module id = 618
// module chunks = 0